import { render, staticRenderFns } from "./global-search.vue?vue&type=template&id=170fca3e&scoped=true&"
import script from "./global-search.vue?vue&type=script&lang=js&"
export * from "./global-search.vue?vue&type=script&lang=js&"
import style0 from "./global-search.vue?vue&type=style&index=0&id=170fca3e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "170fca3e",
  null
  
)

export default component.exports